// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import CompanyConstants from 'constants/CompanyConstants'

const CompanyActions = Marty.createActionCreators({
  updateCompany(companyId, companyParams) {
    return this.app.queries.CompanyQueries.updateCompany(companyId, companyParams)
  },

  setCompanyFromPusher(company) {
    return this.dispatch(CompanyConstants.SET_COMPANY_FROM_PUSHER, company)
  }
})

export default CompanyActions



// WEBPACK FOOTER //
// ./src/scripts/actions/CompanyActions.js